import { SearchField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  search: string
}

export const SearchButton = ({ onSearch, search }: Props) => {
  return (
    <SearchField
      collapsable
      onSearch={onSearch}
      search={search || ''}
      placeholder={i18n.t('common.search')}
    />
  )
}
